const ImageDropZoneEN = {
  ImageDropZone: {
    'ERROR-MESSAGE': 'Wrong image dimensions ',
    'UPLOAD-BUTTON': 'Choose an image',
    'DELETE-BUTTON': 'Remove imagem',
  },
};

const ImageDropZonePT = {
  ImageDropZone: {
    'ERROR-MESSAGE': 'Dimensões da imagem incorretas ',
    'UPLOAD-BUTTON': 'Escolha uma imagem',
    'DELETE-BUTTON': 'Remover a imagem',
  },
};

const ImageDropZoneES = {
  ImageDropZone: {
    'ERROR-MESSAGE': 'Dimensiones de imagen incorrectas',
    'UPLOAD-BUTTON': 'Elige una imagen',
    'DELETE-BUTTON': 'Quitar imagem',
  },
};

export { ImageDropZonePT, ImageDropZoneEN, ImageDropZoneES };
